export const INDEX_URL = '/'
export const CONTINUE_URL = '/continue'
export const WELCOME_BACK_URL = `${CONTINUE_URL}/welcome-back`
export const VERFIY_PHONE_URL = `${CONTINUE_URL}/verify-phone`
export const VERIFY_ACCOUNT_URL = `${CONTINUE_URL}/verify-account`
export const CHANGE_PHONE_URL = `${CONTINUE_URL}/change-phone`
export const CONFIRM_INFO_URL = `${CONTINUE_URL}/confirm-information`
export const COMPLETE_STEPS_URL = `${CONTINUE_URL}/complete-steps`
export const CREATE_PASSWORD_URL = `${CONTINUE_URL}/create-password`
export const EXISTING_ACCOUNT_URL = `${CONTINUE_URL}/existing-account`
export const THANKS_REDIRECT_URL = `${CONTINUE_URL}/thanks`
export const IN_PROGRESS_URL = `${CONTINUE_URL}/in-progress`
export const URLS = {
  INDEX_URL,
  CONTINUE_URL,
  WELCOME_BACK_URL,
  VERFIY_PHONE_URL,
  VERIFY_ACCOUNT_URL,
  CHANGE_PHONE_URL,
  CONFIRM_INFO_URL,
  COMPLETE_STEPS_URL,
  CREATE_PASSWORD_URL,
  EXISTING_ACCOUNT_URL,
  THANKS_REDIRECT_URL,
  IN_PROGRESS_URL
}
